import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

//	///////////////////////
//	MARK: IMPORTS
const Index = lazy(() => import('./Index'))
const DutyIndex = lazy(() => import('./duty/Index'))
const DutyCategoryIndex = lazy(() => import('./duty/category/Index'))

//	///////////////////////
//	MARK: EXPORTS
export const AnalyticsCrewRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--analytics--crew']}>
    <Route path='duty/category/*' element={<DutyCategoryIndex />} />
    <Route path='duty/*' element={<DutyIndex />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
